import React, { useEffect, useState } from 'react'
import './ChangePassword.css'; // Optional external styles
import { Button, Card, Form, Input, message } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { hashWithSalt } from '../../../utils/hash';
import { BE_HOST } from '../../../config/config';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { USER_LOGIN_CLEAR_STATE, USER_TOKEN } from '../../../redux/types';
import { persistor } from '../../../redux/store';
import { axiosInstance } from '../../../utils/axiosInterceptor';
const ChangePassword = ({ isVisible, onClose }) => {
    const token = useSelector((state) => state.userAuth.token?.token);
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate()
  const dispatch = useDispatch();

    const [form] = Form.useForm();
    useEffect(() => {
        if (isVisible) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto'; // Restore on unmount
        };
    }, [isVisible]);
    if (!isVisible) return null;

    // const handleChangePassword = async (values) => {
    //     console.log(values, "Values without hash")
    //     const hashedCurr_password = hashWithSalt(values.currentPassword)
    //     const hashedPassword = hashWithSalt(values?.newPassword)
    //     const hashedConfirmPassword = hashWithSalt(values?.confirmPassword)
    //     console.log(token,"token")
    //     console.log(hashedCurr_password, "  ", hashedPassword, "   ", hashedConfirmPassword, "Values with hash")
    //     setIsLoading(true)
    //     const payload = {
    //         oldPassword: hashedCurr_password,
    //         newPassword: hashedPassword,
    //         confirmPassword: hashedConfirmPassword
    //     };
    //     try {
    //         console.log(" Sending request...");
    //         const response = await axios.post(`${BE_HOST}/users/change-password`,
    //             payload,
    //             {
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                     Authorization: `$Bearer ${token}`
    //                 }
    //             }
    //         );
    //         console.log("Response:", response.data);
    //         message.success(response.data?.message)
    //         localStorage.clear()
    //         persistor.purge();
    //               dispatch({
    //                 type: USER_LOGIN_CLEAR_STATE,
    //               });
    //               dispatch({
    //                 type: USER_TOKEN,
    //                 payload: {
    //                   token : '',
    //                   decodedToken: '', // Parse the JSON string
    //                 },
    //               })
    //         navigate('/Login')
    //     } catch (error) {
    //         console.error(" Error:", error);
    //     } finally {
    //         setIsLoading(false)
    //         console.log(" Cleanup or loading state reset here");
    //     }


    // }

    const handleChangePassword = async (values) => {
  const hashedCurr_password = hashWithSalt(values.currentPassword);
  const hashedPassword = hashWithSalt(values.newPassword);
  const hashedConfirmPassword = hashWithSalt(values.confirmPassword);

  const payload = {
    oldPassword: hashedCurr_password,
    newPassword: hashedPassword,
    confirmPassword: hashedConfirmPassword,
  };

  setIsLoading(true);

  try {
    const response = await axiosInstance.post("/users/change-password", payload);

    message.success(response.data?.message);

    localStorage.clear();
    persistor.purge();
    dispatch({ type: USER_LOGIN_CLEAR_STATE });
    dispatch({ type: USER_TOKEN, payload: { token: "", decodedToken: "" } });
    navigate("/Login");
  } catch (error) {
    console.error("Change Password Error:", error);
    message.error(error.response?.data?.message)
  } finally {
    setIsLoading(false);
    onClose()

  }
};



    return (
        <div className="modal-overlay">
            <div className="modal-content white-modal">
                <button className="modal-close" onClick={onClose}>
                    &times;
                </button>

                <h2 className="modal-title text-[#0EA5E9]">
                    <LockOutlined style={{ fontSize: 26, color: "#0EA5E9" }} />
                    <span className="ml-2">Update Password</span>
                </h2>

                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleChangePassword}
                    className="w-full max-w-md"
                >
                    <Form.Item
                        name="currentPassword"
                        label="Current Password"
                        rules={[{ required: true, message: "Please enter your current password" }]}
                    >
                        <Input.Password
                            prefix={<LockOutlined />}
                            placeholder="Current Password"
                            size="large"
                            className="custom-input"
                        />
                    </Form.Item>

                    <Form.Item
                        name="newPassword"
                        label="New Password"
                        rules={[
                            { required: true, message: "Please enter your new password" },
                            {
                                validator: (_, value) => {
                                    if (!value) return Promise.resolve();
                                    if (value.length < 8)
                                        return Promise.reject("Password must be at least 8 characters");
                                    if (!/[A-Z]/.test(value))
                                        return Promise.reject("Include an uppercase letter");
                                    if (!/\d/.test(value))
                                        return Promise.reject("Include a number");
                                    if (!/[^A-Za-z0-9]/.test(value))
                                        return Promise.reject("Include a special character");
                                    if (/(.)\1{2,}/.test(value))
                                        return Promise.reject("No 3+ repeated characters");
                                    return Promise.resolve();
                                },
                            },
                        ]}
                    >
                        <Input.Password
                            prefix={<LockOutlined />}
                            placeholder="New Password"
                            size="large"
                            className="custom-input"
                        />
                    </Form.Item>

                    <Form.Item
                        name="confirmPassword"
                        label="Confirm Password"
                        dependencies={["newPassword"]}
                        rules={[
                            { required: true, message: "Please confirm your password" },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue("newPassword") === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error("Passwords do not match"));
                                },
                            }),
                        ]}
                    >
                        <Input.Password
                            prefix={<LockOutlined />}
                            placeholder="Confirm Password"
                            size="large"
                            className="custom-input"
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            block
                            size="large"
                            className="custom-btn"
                            loading={isLoading}
                        >
                            Change Password
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>


    )
}

export default ChangePassword
